import React, { Component } from "react";
import { connect } from "react-redux";

// State
import { guestLogin, clearErrors } from "../../../store/actions/user";
import { setActiveCheckoutSection } from "../../../store/actions/checkout";

// Util
import { checkoutSignIn as checkoutSignInGA } from "../../../utils/google-analytics";

class GuestLogin extends Component {
	constructor(props) {
		super(props);
		this.state = {
			email: ""
		};

		this.componentCleanup = this.componentCleanup.bind(this);
	}

	componentDidMount() {
		window.addEventListener("beforeunload", this.componentCleanup);
	}

	componentCleanup() {
		this.props.clearErrors();
		window.removeEventListener("beforeunload", this.componentCleanup);
	}

	componentWillUnmount() {
		this.componentCleanup();
	}

	handleInputChange(event) {
		this.setState({
			[event.target.name]: event.target.value
		});
	}

	handleKeyPress(event, item_id) {
		if (event.key === "Enter") {
			this.handleSubmit(event);
		}
	}

	handleSubmit(event) {
		event.preventDefault();
		this.props.guestLogin(this.state.email).then(result => {
			if (result !== undefined) {
				checkoutSignInGA(this.props.items);
				this.props.setActiveCheckoutSection("delivery");
			}
		});
	}

	render() {
		return (
			<form name="guest-login">
				<h2>Check Out As a Guest</h2>
				<span>You don't need an account to place an order</span>

				<div className="form-field">
					{this.props.errors.email && this.props.loginTypeAttempted === "guest" && <div className="error msg_animate">{this.props.errors.email}</div>}
					<input type="email" name="email" value={this.state.email} placeholder="email@provider.com" onKeyPress={e => this.handleKeyPress(e)} onChange={e => this.handleInputChange(e)} />
				</div>

				<div className="action-elements">
					<button className="btn submit-btn" name="submit" value="submit" onClick={e => this.handleSubmit(e)}>
						<span>Next</span>
					</button>
				</div>
			</form>
		);
	}
}

const mapStateToProps = state => {
	return {
		errors: state.user.errors,
		loginTypeAttempted: state.user.loginTypeAttempted,
		isLoading: state.user.isLoading,
		items: state.cart.items
	};
};

export default connect(mapStateToProps, { guestLogin, clearErrors, setActiveCheckoutSection })(GuestLogin);



// WEBPACK FOOTER //
// ./src/components/checkout/login/GuestLogin.js